import { api } from './api';

export interface DriverProfile {
  id: number;
  userId: number;
  online: boolean;
  latitude?: number;
  longitude?: number;
  vehicleType: 'MOTO' | 'CARRO' | 'BICICLETA' | 'A_PE';
  fcmToken?: string;
  totalEntregas: number;
  ratingMedio: number;
  name: string;
  email: string;
  phone: string;
  avatar?: string;
}

export interface DriverStats {
  hoje: { totalHoje: number; ganhosHoje: number };
  semana: { totalSemana: number; ganhosSemana: number };
  mes: { totalMes: number; ganhosMes: number };
  rating: number;
  totalEntregas: number;
  activeDelivery: AvailableDelivery | null;
}

export interface AvailableDelivery {
  id: number;
  orderId: number;
  status: string;
  distanceKm?: number;
  estimatedMin?: number;
  deliveryAddress: string;
  orderTotal: number;
  deliveryFee?: number;
  deliveryLat?: number;
  deliveryLng?: number;
  orderCreatedAt?: string;
  restaurantName: string;
  restaurantAddress: string;
  restaurantLat?: number;
  restaurantLng?: number;
  customerName: string;
  customerPhone?: string;
}

export interface DeliveryHistory {
  id: number;
  orderId: number;
  status: string;
  distanceKm?: number;
  assignedAt?: string;
  pickedUpAt?: string;
  deliveredAt?: string;
  deliveryAddress: string;
  orderTotal: number;
  deliveryFee?: number;
  restaurantName: string;
  customerName: string;
  deliveryRating?: number;
}

const driverService = {
  register: (formData: FormData) =>
    api.post('/food/driver/register', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),

  /** Conta de estafeta já existente submete a inscrição (BI, carta, veículo). */
  apply: (formData: FormData) =>
    api.post('/food/driver/apply', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),

  /** N = sem inscrição, P = pendente, A = aprovada, R = rejeitada */
  getStatus: () =>
    api.get<{ success: boolean; data: { status: 'N'|'P'|'A'|'R'; reason: string | null; approvedAt: string | null } }>('/food/driver/status'),

  getProfile: () =>
    api.get<{ success: boolean; data: DriverProfile }>('/food/driver/profile'),

  updateProfile: (data: { vehicleType?: string; fcmToken?: string }) =>
    api.put('/food/driver/profile', data),

  toggleOnline: (online: boolean, latitude?: number, longitude?: number) =>
    api.put('/food/driver/online', { online, latitude, longitude }),

  getStats: () =>
    api.get<{ success: boolean; data: DriverStats }>('/food/driver/stats'),

  getAvailableDeliveries: () =>
    api.get<{ success: boolean; data: AvailableDelivery[] }>('/food/deliveries/available'),

  acceptDelivery: (id: number) =>
    api.put(`/food/deliveries/${id}/accept`),

  rejectDelivery: (id: number) =>
    api.put(`/food/deliveries/${id}/reject`),

  updateDeliveryStatus: (id: number, status: string) =>
    api.put(`/food/deliveries/${id}/status`, { status }),

  updateLocation: (id: number, latitude: number, longitude: number) =>
    api.put(`/food/deliveries/${id}/location`, { latitude, longitude }),

  getHistory: (page = 1, limit = 20) =>
    api.get<{ success: boolean; data: DeliveryHistory[]; pagination: { page: number; limit: number; total: number } }>(
      `/food/driver/history?page=${page}&limit=${limit}`
    ),
};

export default driverService;
